import React from 'react';

export const pageMeta = {
  "name": "JS IE / Edge",
  "link": "/javascript/versions/ie-edge"
};

export default function JavascriptVersionsIeEdge() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS IE / Edge</h2>
      <p>Route: /javascript/versions/ie-edge</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
